import React from 'react';
import { Grid } from 'style';
import { DataStoreService } from 'utils';
import ListComponent, { ItemComponent, ListWrapper } from '../../common/lists/lists.component';
import PersonCardComponent from '../subcomponents/personCard.component';

class PersonList extends ListComponent {
  constructor(props) {
    super(props);

    this.state = {
      people: null,
    };
  }

  componentDidMount() {
    this.setState(() => ({
      people: DataStoreService.getPeople(),
    }));
  }

  render() {
    const { people } = this.state;
    return people ? (
      <Grid.InnerContainer id="CaseList">
        <Grid.Row>
          <Grid.Col>
            <ListWrapper id="wrapper" margin={`${100 / 18 * .5}`}>
              {people.edges.map(data => (
                <ItemComponent
                  align={'flex-start'}
                  itemsPerRow={5}
                  maxWidthMobile={`${100 / 18 * 6}vw`}
                  key={data.node.slug}
                  onChange={this.onVisible}>
                  <PersonCardComponent
                    {...{
                      name: data.node.name,
                      title: data.node.title,
                      image: data.node.image,
                      slug: data.node.slug,
                    }}
                  />
                </ItemComponent>
              ))}
              <ItemComponent itemsPerRow={5} />
              <ItemComponent itemsPerRow={5} />
              <ItemComponent itemsPerRow={5} />
              <ItemComponent itemsPerRow={5} />
            </ListWrapper>
          </Grid.Col>
        </Grid.Row>
      </Grid.InnerContainer>
    ) : (
        <div />
      );
  }
}

export default PersonList;
